meedy.factory('meedy.opinionModel', ['$rootScope', 'meedy.baseModel', 'meedy.opinionService',
  function ($rootScope, baseModel, opinionService) {

    function OpinionModel() {

      this.save = function (opinion) {
        opinionService.save(opinion).then(
          function (data) {
            $rootScope.$broadcast(Event.MEEDY.OPINION.SAVE.SUCCESS, data);
            baseModel.broadcastOperationSucceeded();
          },
          function (error) {
            $rootScope.$broadcast(Event.MEEDY.OPINION.SAVE.ERROR, error);
            baseModel.broadcastOperationFailed();
          }
        )
      };

    }

    return new OpinionModel();
  }
]);
